import Axios from 'axios';
import store from 'store';
import storage from 'helpers/storage';

import responseStatus from 'helpers/responseStatus';

import config from 'config';
// import { useDispatch } from 'react-redux';
import {
  startLoading,
  endLoading,
  showLoading
} from 'features/loading/loadingSlice';
import { toast } from 'react-toastify';
import { errors, unAuthorizedErrors } from 'helpers/variables';
import { checkAuthToken, getCookie } from 'helpers/generic.methods';
import { globalLogout } from 'helpers/generic-logout-method';
import { RESETPASSWORD } from './endpoints';

// const dispatch = useDispatch();
// const language = useSelector(selectLangauge);
/**
 * @name @ApiService
 * @description Default Api Service for Auth and Defaul Queries
 * */

/* General ApiServices requests and configurations */

/** Creating Axios instance */
const instance = Axios.create({
  baseURL: config.apiUrl + config.apiVersion
});
/** Creating Axios instance */
const WCFInstance = Axios.create({
  baseURL: config.apiWCFUrl
});

const ApiServices = {
  instance,
  WCFInstance,
  /**
   * @name @init
   * @description init axios interceptor on entry point and set/remove auth on app load
   **/
  init() {
    instance.interceptors.request.use(config => {
      store.dispatch(showLoading(true));
      store.dispatch(startLoading());
      if (
        !checkAuthToken() &&
        !allowedUnAuthUrls(config.data || {}).includes(config.url)
      ) {
        toast.error(errors.inValidAuthToken);
        globalLogout(true);
        return false;
      }
      return config;
    });

    instance.interceptors.response.use(
      function (response) {
        // destroy Loader
        destroyLoader();
        // Do something with response data
        return response;
      },
      function (error) {
        if (error?.response?.status === responseStatus.UNAUTHORIZED) {
          storage.removeItem('Auth');
          storage.removeItem('Profile');
        }
        // Do something with response error
        destroyLoader();
        return Promise.reject(error);
      }
    );

    // WCF instance for Legacy Portal APIs
    WCFInstance.interceptors.request.use(config => {
      store.dispatch(showLoading(true));
      store.dispatch(startLoading());
      if (!checkAuthToken() && !allowedUnAuthUrls.includes(config.url)) {
        toast.error(errors.inValidAuthToken);
        globalLogout(true);
        return false;
      }
      return config;
    });

    WCFInstance.interceptors.response.use(
      function (response) {
        // destroy Loader
        destroyLoader();
        // Do something with response data
        return response;
      },
      function (error) {
        if (error?.response?.status === responseStatus.UNAUTHORIZED) {
          storage.removeItem('Auth');
          storage.removeItem('Profile');
        }
        // Do something with response error
        destroyLoader();
        return Promise.reject(error);
      }
    );

    /* Setting Auth Header*/
  },

  /* General query for get request */
  query(resource, params) {
    return instance.get(resource, params).catch(error => {
      throw new Error(`ApexChat Generic ApiServices ${error}`);
    });
  },

  /* General get request */
  get(resource, headers) {
    return instance.get(resource, {
      headers
    });
  },

  /* Get request with params*/
  getWithParams(resource, params) {
    this.setAuthHeader();
    return instance.get(resource, params).catch(error => {
      if (error.message === 'Network Error')
        return toast.error(errors.networkError);
      return error?.response?.data?.error;
    });
  },

  /* General post request */
  post(resource, params) {
    this.setAuthHeader();
    return instance.post(resource, params).catch(error => {
      throw new Error(`ApexChat Post ApiServices ${error}`);
    });
  },

  /* General put request */
  put(resource, params) {
    this.setAuthHeader();
    return instance.put(resource, params).catch(error => {
      throw new Error(`ApexChat Put ApiServices ${error}`);
    });
  },

  /* General delete request */
  delete(resource, params) {
    return instance.delete(`${resource}/${params}`).catch(error => {
      throw new Error(`ApexChat Delete ApiServices ${error}`);
    });
  },
  setAuthHeader() {
    const auth = getCookie('Auth');
    if (auth) {
      instance.defaults.headers.common['Authorization'] = `Bearer ${auth}`;
    } else {
      instance.defaults.headers.common['Authorization'] = `Bearer`;
    }
  },

  /* WCF General get request */
  WCF_get(resource, headers) {
    this.setWCFAuthHeader();
    return WCFInstance.get(resource, {
      headers
    });
  },
  /* WCF General get request */
  WCF_post(resource, params) {
    this.setWCFAuthHeader();
    return WCFInstance.post(resource, params).catch(error => {
      throw new Error(`ApexChat WCF Post ApiServices ${error}`);
    });
  },

  setWCFAuthHeader() {
    const auth = getCookie('Auth');
    if (auth) {
      WCFInstance.defaults.headers.common['Authorization'] = `Bearer ${auth}`;
    } else {
      WCFInstance.defaults.headers.common['Authorization'] = `Bearer`;
    }
  },
  dataWrapper(data, status) {
    // data wrapper will be removed if WebApi project will send data in ideal way. with status code/data/message etc..

    switch (status) {
      case 'success':
        return {
          status: data.status || status,
          code: data.code || 200,
          data: data,
          message: data.message || 'success'
        };
      case 'error':
        return {
          status: data.status || status,
          code: data.code || 400,
          data: data,
          message: data.message || 'error'
        };
      default:
        return {
          status: 'error',
          code: 400,
          data: null,
          message: 'error'
        };
    }
  }
};

// destroy Loader: Complete loading to full and set show loading false
const destroyLoader = () => {
  store.dispatch(endLoading());
  setTimeout(() => {
    store.dispatch(showLoading(false));
  }, 500);
};

export default ApiServices;

export const allowedUnAuthUrls = data => [
  '/login',
  '/auth/verifyToken',
  RESETPASSWORD(data)
];
